import btnManagement from '../util/button-managment';
// function is used to update the post numbers after a loop
export default function updatePostNumbers(rootEl, cardClass, count, btn) {

	if (rootEl instanceof window.HTMLElement) {
		const total = rootEl.getAttribute('data-total');
		const postNumber = rootEl.querySelectorAll(`.${cardClass}`);
		const textDisplay = rootEl.querySelectorAll(
			'p.post-numbers__info span.current-count'
		);
		const totalCount = rootEl.querySelectorAll(
			'p.post-numbers__info span.total-count'
		);
		const $loadMoreButton = rootEl.querySelector(
			'.load-more-button__button'
		);
		textDisplay.forEach(function (el) {
			if (el instanceof window.HTMLElement) {
				el.textContent = postNumber.length.toString();
			}
		});

		//Remove button if results have hit the total
		if (totalCount[0].textContent.toString() === postNumber.length.toString()) {
			if($loadMoreButton) {
				btnManagement($loadMoreButton, 'hide'); 
			}
		}

		//If the filter buttons are clicked update total count 
		if(btn != 'load-more') {
			totalCount.forEach(function (el) {
				if (el instanceof window.HTMLElement) {
					el.textContent = count;
				}
			});
		}
	}
}
